// Shared country dial-code list used anywhere a phone number is collected
// (owner login, team member mobile entry, etc).
export const countryCodes = [
  { code: "US", dial_code: "+1" },
  { code: "MX", dial_code: "+52" },
  { code: "HK", dial_code: "+852" },
  { code: "IN", dial_code: "+91" },
];

export default countryCodes;
